import { DetailSupportFormAnnounce6Component } from "../../../components/SupportSystem/SupportForm/DetailSupportFormAnnounce6Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function DetailSupportFormAnnounce6Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <DetailSupportFormAnnounce6Component />
            <Footer />
        </div>
        // 
    )

}